"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "@/components/pop-ui/pop-toast";
import { useAuth } from "@/providers/auth-provider";
import { useORPC } from "@/providers/orpc-provider";
export function useCheckUserExists() {
  const $ = _c(11);
  const {
    isAuthenticated,
    logout
  } = useAuth();
  const orpc = useORPC();
  const {
    t
  } = useTranslation();
  const intervalRef = useRef(null);
  const orpcRef = useRef(orpc);
  let t0;
  let t1;
  if ($[0] !== orpc) {
    t0 = () => {
      orpcRef.current = orpc;
    };
    t1 = [orpc];
    $[0] = orpc;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isAuthenticated || $[4] !== logout || $[5] !== t) {
    t2 = async () => {
      if (!isAuthenticated) {
        return;
      }
      ;
      try {
        await orpcRef.current.user.checkUserExists.call({});
      } catch (t3) {
        const error = t3;
        if (error?.code === "user:not_found") {
          toast.error(t("realtime.user.logout.forced", "You have been forced to logout"));
          await logout?.({
            redirectUrl: "/"
          });
          return;
        }
        console.error("Error checking user status:", error);
      }
    };
    $[3] = isAuthenticated;
    $[4] = logout;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const checkUserStatus = t2;
  let t3;
  let t4;
  if ($[7] !== checkUserStatus || $[8] !== isAuthenticated) {
    t3 = () => {
      if (isAuthenticated) {
        intervalRef.current = setInterval(checkUserStatus, 180000);
      } else {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    };
    t4 = [isAuthenticated, checkUserStatus];
    $[7] = checkUserStatus;
    $[8] = isAuthenticated;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
}